import {UserEntity} from "../../../proto/generated/api_entities_pb";
import {IUser} from "./userReducerTypes";
import {roleFromBackendIdentifier} from "../../../utils/helpers/acl/mapRoleAndBackendIdentifier";
import {UserStatus} from "../../../utils/constans/statuses/userStatuses";
import {mapTimeZoneEntityToITimezone} from "../fleetReducer/fleetMappers";
import {DistanceUnit, DEFAULT_DISTANCE_UNIT} from "../../../utils/constans/statuses/distanceUnits";

export const mapUserEntityToIUser = (item: UserEntity): IUser => {
  const role = roleFromBackendIdentifier(item.getRole());

  const timezone = item.getTimezone();
  const currency = item.getCurrency();

  return {
    id: item.getUserid(),
    role: role,
    firstName: item.getFirstname(),
    lastName: item.getLastname(),
    middleName: item.getMiddlename(),
    email: item.getEmail(),
    userStatus: item.getUserstatusid() as UserStatus,
    phone: item.getPhone(),
    timezone: timezone ? mapTimeZoneEntityToITimezone(timezone) : undefined,
    distanceUnit: (item.getDistanceunit() || DEFAULT_DISTANCE_UNIT) as DistanceUnit,
    currency: currency ? {
      id: currency.getCurrencyid(),
      name: currency.getName(),
    } : undefined,
  }
}